import { gql } from "@apollo/client";

export const createAppForOrg = gql`
    mutation CreateApp($orgId: String, $appName: String, $platformType: MyLensesPlatformType) {
        createApplication(
            input: { orgId: $orgId, appInfo: { internalAppName: $appName, platformType: $platformType } }
        ) {
            appInfo {
                orgId
                internalAppName
                versions {
                    versionName
                    version
                }
                appId
            }
        }
    }
`;
